export default "__VITE_ASSET__DlQMrkXN__"